import { observable, action } from "mobx";
import { httpClient } from "../../../utils/httpClient";
import api from "../../../config/api"
const { offisetting } = api


class ArtMaintenance {


  @action async updataStore(key, value) {
    let type = typeof key;
    let _self = this;
    switch (type) {
      case 'object':
        Object.keys(key).forEach(item => { _self[item] = key[item]; });
        break;
      default:
        _self[key] = value;
    }
  }

  @observable dictKey = '';
  @observable dictionariesList = [];
  @observable dictionariesLoading = false;

  @action async getDictionaries(params) {
    try {
      this.dictionariesLoading = true;
      const { data } = await httpClient.get(offisetting.DICT_DICTIONARIES, { params });
      if (data && data[0] && data[0].dictKey) {
        this.dictKey = data[0].dictKey;
      }
      this.dictionariesList = data || [];
      this.dictionariesLoading = false;
    } catch (ex) {
      this.dictionariesList = [];
    }
  }

  deepTree(data) {
    if (data.childNodes) {
      const child = data.childNodes.map(item => this.deepTree(item))
      return { ...data, key: data.id, children: child.concat([{ id: 'operation', parentNodeId: data.id, key: `${data.id}_${new Date().getTime()}` }]) };
    }
    return { ...data, key: data.id, children: [{ id: 'operation',parentNodeId: data.id, key: `${data.id}_${new Date().getTime()}` }] }
  }

  @observable systemTreeList = [];
  @observable systemTreeLoading = false;

  @action async getSystemTree(params) {
    try {
      this.systemTreeLoading = true;
      const { data } = await httpClient.post(offisetting.GET_SYSTEM_TREE, params);
      const result = data && data.map(item => this.deepTree(item));
      if(result.length) {
        this.systemTreeList = result;
      } else {
        this.systemTreeList = result.concat([{ id: 'operation', key: new Date().getTime() }]);
      }
      this.systemTreeLoading = false;
    } catch (ex) {
      this.systemTreeList = [];
      this.systemTreeLoading = false;
    }
  }

  // 添加菜单
  @observable addMenuLoading = false;
  @action async addMenu(params) {
    return httpClient.post(offisetting.ADD_ADMIN_RIGHT_MENU, params);
  }

  // 编辑菜单
  @action async upDateMenu(params) {
    return httpClient.post(offisetting.UP_ADMIN_RIGHT_MENU, params);
  }

}

export default new ArtMaintenance();
